<script>

    import { replace } from 'svelte-spa-router'

    import Button from '../$components/button.svelte'
    import Image from '../$components/image.svelte'

</script>

<div class="items center">
    <Image src="/images/brand.png" size="128x128" />
</div>

<hr>

<div class="columns">
    <div class="column">
        <div class="title is-5">Bienvenido, tu cuenta ha sido activada, da click en el botón para iniciar sesión</div>
    </div>
</div>

<div class="columns">
    <div class="column">
        <Button on:click={() => replace('#/login')} text="Iniciar sesión" icon="save" color="primary" fullwidth={true} />
    </div>
</div>
